<app-menu>
    <!-- <ng-container *ngIf="isCustomDetailsOpen">
        <app-contact-details
        (tabSelectionChange)="handleTabSelectionChange($event)"></app-contact-details>
      </ng-container> -->
    <div class="grid-header">
      <div class="grid-title">
        &nbsp;<i style="font-size: 30px;" class="fa-solid fa-file-text"></i>&nbsp;&nbsp;Lading Document List
      </div>
    </div>
    <ag-grid-angular 
      style="width: 100%; height: 100%;" 
      class="ag-theme-alpine" 
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef" 
      [animateRows]="true" 
      [rowData]="rowData" 
      [rowModelType]="'serverSide'"
      [cacheBlockSize]="100" 
      [maxBlocksInCache]="10" 
      [masterDetail]="true" 
      (gridReady)="onGridReady($event)" #agGrid
    >
    </ag-grid-angular>
  </app-menu>